import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../../constants";
import Icon from "../../components/general/icon";
import SearchBox from "../../components/general/searchBox";
import Pagination from "../../components/general/table/pagination";
import DeleteDeviceModal from "../../components/devices/deleteDeviceModal";
import { useWindowSize } from "../../../hook/useWindowSize";
import DeviceTable from "../../components/devices/dataList/deviceTable";
import DeviceCardsBox from "../../components/devices/dataList/deviceCardsBox";
import { useGetDevices } from "../../../hook/request/devices";
import { useMySearchParams } from "../../../hook/useMySearchParams";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";

const dataListTitles = [
  "کد دستگاه",
  "نوع دستگاه",
  "تاریخ ایجاد",
  "تعداد تخصیص",
  "",
]

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

const DevicesList = () => {

  const [width] = useWindowSize();
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();

  const [devicesData, setDevicesData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getDevicesRequest = useGetDevices(getQueryParams(filterValues));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || ""
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    getDevicesRequest?.data?.data?.result && 
      setDevicesData(getDevicesRequest?.data?.data?.result)
  }, [getDevicesRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const doChangePage = (param: any) => {
    updateSearchParams({
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    })
  }

  return (
    <>
      <div className="card-box">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی دستگاه"
            />
          </div>
          {
            findAccessInAccessList('DEVICE_CREATE') &&
            <div className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0">
              <Link to={ROUTES.DEVICE_ADD.PATH} className="btn btn-primary rounded d-flex align-items-center fw-bold px-4">
                <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="add-square"/></span>
                افزودن دستگاه
              </Link>
            </div>
          }
        </section>

        <section className="table-cont table-responsive">
          {
            width < 900 ?
              <DeviceCardsBox
                dataList={devicesData}
                dataListTitles={dataListTitles}
                isRequesting={getDevicesRequest.isPending}
              /> :
              <DeviceTable
                dataList={devicesData}
                dataListTitles={dataListTitles}
                isRequesting={getDevicesRequest.isPending}
              />
          }
          <Pagination
            paginationData={{...filterValues, ...devicesData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      
      <DeleteDeviceModal />
    </>
  );
};

export default DevicesList;